import { render, staticRenderFns } from "./article-element.vue?vue&type=template&id=99d97ed8&scoped=true&"
import script from "./article-element.vue?vue&type=script&lang=js&"
export * from "./article-element.vue?vue&type=script&lang=js&"
import style0 from "./article-element.vue?vue&type=style&index=0&id=99d97ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d97ed8",
  null
  
)

export default component.exports